<h2 mat-dialog-title>Unpair Participants</h2>

<mat-dialog-content>
  <div class="participant-info">
    <div class="participant-row">
      <span class="label">Recipient:</span>
      <span class="value">
        <b>{{ data.pair.recipient.enisNumber }}</b> - {{ data.pair.recipient.firstName }} {{ data.pair.recipient.lastName }}
      </span>
    </div>

    <div class="participant-row">
      <span class="label">Donor:</span>
      <span class="value">
        <b>{{ data.pair.donor.enisNumber }}</b> - {{ data.pair.donor.firstName }} {{ data.pair.donor.lastName }}
      </span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="warn" (click)="onUnpair()">Unpair</button>
</mat-dialog-actions>
